import { FolderOutline } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const { title, createDescription } = RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.Scorm];

const config: ContentConfigProps = {
  routes: {
    create: routes.ScormCreator,
    edit: routes.ScormEditor,
    duplicate: routes.ScormDuplicate,
    details: routes.ScormDetails,
    manageDetails: routes.AdminScormDetails,
  },
  label: { title, createDescription },
  icons: {
    Type: FolderOutline,
    Create: FolderOutline,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
